import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CATEGORIES } from "@/lib/categories";
import { HERO } from "@/constants/testIds";

const CategoryRow = ({ category, index }) => {
  const Icon = category.icon;
  return (
    <li>
      <Link
        to={`/proteger/${category.slug}`}
        data-testid={HERO.category(category.slug)}
        className="group flex items-center justify-between py-5 border-b border-razmek hover:border-razmek-gold transition-colors"
      >
        <div className="flex items-center gap-5">
          <span className="font-serif text-razmek-gray text-sm w-7">
            {String(index + 1).padStart(2, "0")}
          </span>
          <Icon
            size={18}
            className="text-razmek-blue group-hover:text-razmek-gold transition-colors"
          />
          <span className="font-serif text-2xl text-razmek-dark group-hover:text-razmek-blue transition-colors">
            {category.label}
          </span>
        </div>
        <ArrowUpRight
          size={16}
          className="text-razmek-gray group-hover:text-razmek-gold group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all"
        />
      </Link>
    </li>
  );
};

export const HeroCategoriesList = () => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ delay: 0.4, duration: 0.7 }}
    className="border-t border-razmek pt-6 px-5 pb-2 bg-white/70 backdrop-blur-sm"
  >
    <div className="eyebrow text-razmek-gray">Selecciona</div>
    <ul className="mt-5">
      {CATEGORIES.map((cat, i) => (
        <CategoryRow key={cat.slug} category={cat} index={i} />
      ))}
    </ul>
  </motion.div>
);
